// replaced with stub re-exporting shared-components implementation
export { TextWithCopy as default, TextWithCopy } from "@shared/src/components/ui/common/misc/TextWithCopy";
